module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/radiator-modern-style/ModernStyleRadiator.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/radiator-modern-style/ModernStyleRadiator.png
// module id = 610
// module chunks = 0